import { c as _c } from "react/compiler-runtime";
import type { PublicTraceEntry } from '@onefootprint/request-types/dashboard';
import { Button } from '@onefootprint/ui';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData } from '../../conditional-form';
import BaseBranch from '../base-branch';
import Rule from '../rule';
type BranchProps = {
  index: number;
  trace?: PublicTraceEntry;
  canEdit: boolean;
  languageName: string;
  nodeId: string;
};
const Branch = t0 => {
  const $ = _c(30);
  const {
    index,
    trace,
    canEdit,
    languageName,
    nodeId
  } = t0;
  const {
    t
  } = useTranslation("playbook-builder");
  const {
    control
  } = useFormContext();
  const t1 = `branches.${index}.rules`;
  let t2;
  if ($[0] !== control || $[1] !== t1) {
    t2 = {
      control,
      name: t1
    };
    $[0] = control;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    fields,
    append,
    update,
    remove
  } = useFieldArray(t2);
  let t3;
  if ($[3] !== append) {
    t3 = () => {
      append({
        ruleId: `new_${crypto.randomUUID()}`,
        ruleExpression: "",
        isPendingDeletion: false
      });
    };
    $[3] = append;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleAdd = t3;
  let t4;
  if ($[5] !== remove || $[6] !== update) {
    t4 = (field, ruleIndex) => {
      if (field.ruleExpression) {
        update(ruleIndex, {
          ...field,
          isPendingDeletion: true
        });
      } else {
        remove(ruleIndex);
      }
    };
    $[5] = remove;
    $[6] = update;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleRemove = t4;
  let t5;
  if ($[8] !== canEdit || $[9] !== fields || $[10] !== handleRemove || $[11] !== index || $[12] !== languageName || $[13] !== nodeId || $[14] !== t || $[15] !== trace || $[16] !== update) {
    t5 = fields.length > 0 ? <><div className="text-label-2 text-primary">{t(_temp)}</div><ul className="flex flex-col list-none gap-2">{fields.map((field_0, ruleIndex_0) => <Rule key={field_0.id} branchIndex={index} ruleIndex={ruleIndex_0} onRemove={() => handleRemove(field_0, ruleIndex_0)} onReAdd={() => update(ruleIndex_0, {
          ...field_0,
          isPendingDeletion: false
        })} isPendingDeletion={field_0.isPendingDeletion} trace={trace} languageName={languageName} nodeId={nodeId} />)}</ul></> : <div className="text-body-2 text-tertiary">{canEdit ? t(_temp2) : t(_temp3)}</div>;
    $[8] = canEdit;
    $[9] = fields;
    $[10] = handleRemove;
    $[11] = index;
    $[12] = languageName;
    $[13] = nodeId;
    $[14] = t;
    $[15] = trace;
    $[16] = update;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== canEdit || $[19] !== handleAdd || $[20] !== t) {
    t6 = canEdit && <div className="flex justify-start"><Button size="compact" onClick={handleAdd} variant="secondary">{t(_temp4)}</Button></div>;
    $[18] = canEdit;
    $[19] = handleAdd;
    $[20] = t;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t5 || $[23] !== t6) {
    t7 = <div className="flex flex-col p-4 gap-3">{t5}{t6}</div>;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== canEdit || $[26] !== index || $[27] !== t7 || $[28] !== trace) {
    t8 = <BaseBranch trace={trace} canEdit={canEdit} branchIndex={index} className="border-b border-tertiary">{t7}</BaseBranch>;
    $[25] = canEdit;
    $[26] = index;
    $[27] = t7;
    $[28] = trace;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  return t8;
};
export default Branch;
function _temp($) {
  return $.rulesNode.branch.rules;
}
function _temp2($_0) {
  return $_0.rulesNode.branch.emptyRules;
}
function _temp3($_1) {
  return $_1.rulesNode.branch.emptyRulesReadOnly;
}
function _temp4($_2) {
  return $_2.rulesNode.branch.addRuleButton;
}